const transformDefault = () => ({
  componentType: 'default',
});

export default transformDefault;
